import { RiFileList3Fill } from "react-icons/ri";
import {
  COSTUM,
  DATE,
  SELECT,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const MaxsulotOborot = {
  title: "Маҳсулот айланмаси",
  path: "/hisobot/maxsulot-oborot",
  icon: <RiFileList3Fill></RiFileList3Fill>,
  type: HISOBOT,
  allData: [
    { value: "brend_id", prop: "brendlar", get: "nomi" },
    { value: "tovar_id", prop: "tovarlar", get: "nomi" },
  ],
  hisobotActions: [
    {
      grid: "1fr 1fr 1fr 2fr 1fr",
      inputs: [
        {
          label: "Сана 1",
          name: "sana1",
          type: DATE,
        },
        {
          label: "Сана 2",
          name: "sana2",
          type: DATE,
          secondDate: true,
        },
        {
          label: "Бренд",
          name: "brend_id",
          type: SELECT,
          allData: {
            type: "brendlar",
            key: "Id",
            text: "nomi",
          },
        },
        {
          label: "Махсулотлар",
          name: "maxsulot_id",
          type: SELECT,
          allData: {
            dependent: "brend_id",
            type: "tovarlar",
            key: "Id",
            text: "nomi",
          },
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default MaxsulotOborot;
